import React from 'react';
import { Button } from './ui/button';
import keratin from "../assets/images/keratin.jpg";

const HairTreatment = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Hair Treatment Services</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                A hair treatment that uses keratin to substantially improve the health, condition, and luster of unmanageable/frizzy hair.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Our treatments include keratin, smoothening, and spa services to restore and rejuvenate your hair.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book Appointment
              </Button>
            </div>
            <div>
              <img src={keratin} alt="Hair Treatment" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HairTreatment;
